module.exports = {
  /**
   * @param {{ listingTitle?: string, stageTitle?: string, stageDetail?: string }} opts
   */
  panel: function panel() {
    var _ref = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
      _ref$listingTitle = _ref.listingTitle,
      listingTitle = _ref$listingTitle === void 0 ? '' : _ref$listingTitle,
      _ref$stageTitle = _ref.stageTitle,
      stageTitle = _ref$stageTitle === void 0 ? 'Preparing purchase' : _ref$stageTitle,
      _ref$stageDetail = _ref.stageDetail,
      stageDetail = _ref$stageDetail === void 0 ? '' : _ref$stageDetail;
    var lead = listingTitle ? "Preparing your purchase of <strong>".concat(listingTitle, "</strong>.") : 'Preparing your purchase.';
    return "\n<article class=\"purchase monitor saito-overlay-panel retain-surface\" aria-labelledby=\"purchase-monitor-title\" aria-live=\"polite\" aria-busy=\"true\">\n  <div class=\"stack\">\n    <div class=\"saito-spinner\" aria-hidden=\"true\"></div>\n    <h2 class=\"title\" id=\"purchase-monitor-title\" data-monitor-stage-title>".concat(stageTitle, "</h2>\n    <p class=\"lead\">").concat(lead, "</p>\n    <p class=\"subtitle\" data-monitor-stage-detail>").concat(stageDetail, "</p>\n  </div>\n</article>");
  }
};